"use strict";
// Copyright © Veeam Software Group GmbH
Object.defineProperty(exports, "__esModule", { value: true });
exports.getTextAlign = void 0;
const DataGridNew_1 = require("../../..");
const Text_1 = require("../../../../Text");
const getTextAlign = (headerJustify) => {
    switch (headerJustify) {
        case DataGridNew_1.DATA_GRID_NEW_COLUMN_JUSTIFY.left:
            return Text_1.TEXT_ALIGN.left;
        case DataGridNew_1.DATA_GRID_NEW_COLUMN_JUSTIFY.center:
            return Text_1.TEXT_ALIGN.center;
        case DataGridNew_1.DATA_GRID_NEW_COLUMN_JUSTIFY.right:
            return Text_1.TEXT_ALIGN.right;
        default:
            return undefined;
    }
};
exports.getTextAlign = getTextAlign;
//# sourceMappingURL=getTextAlign.js.map